<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="material-table-widget dashboard_top_bar">
              <div class="row">
                <div class="col-md-7">
                  <button class="btn btn-default btn-new" id="show-modal" @click="ActivityModal = true"><i class="fa fa-plus"></i>&nbsp;新增待辦事項</button>
                </div>
                <div class="col-md-5 form-inline text-right flex-end display-block">
                  <button @click="goSetting()" class="btn btn-default"><i class="zmdi zmdi-settings"></i></button>
                  <select class="form-control" v-model="owner_filter" @change="setFilterDealOwner()">
                    <option v-for="user in company_users" v-bind:value="user.value">{{user.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="widget-wrap">
              <FullCalendar v-bind:defaultView="view_type" ref="fullCalendar" 
              :locale="locale"
              :editable="true"
              :plugins="calendarPlugins"
              :droppable="true"
              :events="activities" 
              :startEditable="true"
              :header="header"
              :navLinks=true
              :eventLimit=true
              :selectable= true
              :selectMirror = true
              @changeMonth="changeMonth"
              @eventClick="eventClick"
              @dateClick="dateClick"
              @moreClick="moreClick"
              @eventDrop="eventDrop"
              @eventResize="eventResize"
              @select="select"
              @viewSkeletonRender = "viewSkeletonRender"
              />
            </div> 
          </div>
        </div>
      </div>
    </section>
    <!-- modal template start-->
    <div v-if="ActivityModal || editModal" @keyup.esc="cancelAddActivity()">
      <div class="modal-mask" style="background:none;">
        <div class="modal-wrapper" @click="cancelAddActivity()">
          <div class="modal-container col-md-7" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header text-center">
                <h5 v-if="ActivityModal">新增待辦事項</h5>
                <h5 v-else>修改待辦事項</h5>
              </div>
              <a href="#" class="btn-close" @click="cancelAddActivity()">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms scroll">
              <div class="text-left form-group">
                <div class="btn-group" role="group" aria-label="...">
                  <button v-for="category in activity_categories" type="button" class="btn btn-default" @click="temp_activity.activity_category_id=category.id" :class="{active: temp_activity.activity_category_id === category.id}"><i v-bind:class="category.icon"></i> {{category.title}}</button>
                </div>
              </div>
            	<div class="row">
            		<div class="col-md-3">
                  <div class="form-group">
              			<div class="input left-icon-input">
                        <label class="icon-left" for="text">
                            <i class="fa fa-calendar"></i>
                        </label>
                        <datepicker input-class="form-control" v-model="temp_activity.start_date" language="zh" @selected="startDateMove" :format="'yyyy-MM-dd'"></datepicker>
                    </div>
                  </div>
            		</div>
            		<div class="col-md-2" v-if="temp_activity.allDay == false">
                  <div class="form-group">
        			      <vue-timepicker v-model="temp_activity.start_time" placeholder="時間" format="HH:mm" :minute-interval="5"></vue-timepicker>
                  </div>
            		</div>
                <div class="col-md-1">
                  <span style="line-height:39px;font-size:20px;">～</span>
                </div>
                <div class="col-md-2" v-if="temp_activity.allDay == false">
                  <div class="form-group">
                    <vue-timepicker v-model="temp_activity.end_time" placeholder="時間" format="HH:mm" :minute-interval="5"></vue-timepicker>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <div class="input left-icon-input">
                        <label class="icon-left" for="text">
                            <i class="fa fa-calendar"></i>
                        </label>
                        <datepicker input-class="form-control" v-model="temp_activity.end_date" language="zh" @selected="startDateMove" :format="'yyyy-MM-dd'"></datepicker>
                    </div>
                  </div>
                </div>
                <div class="col-md-2" v-if="temp_activity.allDay == true">
                  <button @click="temp_activity.allDay=false" class="btn btn-default">增加時間</button>
                </div>
          		</div>
              <p class="alert alert-warning" v-if="temp_activity.time_warning">結束時間必須在開始時間之後</p>
              <div class="row grid-divider">
                <div class="col-6">
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fa fa-tasks"></i></label>
                      <input class="form-control" type="text" placeholder="待辦事項*" v-model="temp_activity.title" name="title" v-validate="'required'">
                      <i v-show="errors.has('title')" class="fa fa-warning"></i>
                      <span v-show="errors.has('title')" class="help is-danger">標題為必填
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label for="text" class="icon-left"><i class="fas fa-map-marker"></i></label>
                      <input class="form-control" type="text" placeholder="地點" v-model="temp_activity.location">
                    </div>
                  </div>
                  <div class="form-group">
                    <textarea v-autosize="temp_activity.content" rows="3" class="form-control" placeholder="事項備註" v-model="temp_activity.content">{{temp_activity.content}}</textarea>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <div class="input left-icon-input">
                      <label class="icon-left" for="text">
                          <i class="fa fa-user"></i>
                      </label>
                      <select v-model="temp_activity.user_id" class="form-control">
                        <option value="">指派*</option>
                        <option v-for="user in company_users" v-bind:value="user.value">{{user.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group" v-if="temp_activity.contact_id==''">
                    <div class="input left-icon-input">
                      <label class="icon-left" for="text">
                          <i class="fa fa-file-invoice-dollar"></i>
                      </label>
                      <select v-model="temp_activity.deal_id" class="form-control">
                        <option value="">關係訂單</option>
                        <option v-for="deal in deals" v-bind:value="deal.value">{{deal.title}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group" v-if="temp_activity.deal_id==''">
                    <div class="input left-icon-input">
                      <label class="icon-left" for="text">
                          <i class="fa fa-user"></i>
                      </label>
                      <autocomplete v-bind:url="url" anchor="name" label="" param="keyword" name="autocomplete" placeholder="關係客戶" v-model="temp_activity.contact_id" :classes="{ input: 'form-control login-frm-input contact_name', wrapper: 'input-wrapper'}" :process="process_contact_JSON" :onSelect="handle_contact_Select" :onInput="set_contact_Value" :customHeaders=auth_token :customParams="{ type: 'contact' }">
                      </autocomplete>
                    </div>
                  </div>  
                  <div class="form-group">
                    <div class="btn-group" role="group" aria-label="...">
                      <button type="button" class="btn btn-default" @click="temp_activity.activity_priority='low';active_priority='low'" :class="{active: active_priority === 'low'}"><i class="fa fa-flag" style="color:gray"></i>優先度低</button>
                      <button type="button" class="btn btn-warning" @click="temp_activity.activity_priority='middle';active_priority='middle'" :class="{active: active_priority === 'middle'}"><i class="fa fa-flag"></i>優先度中</button>
                      <button type="button" class="btn btn-danger" @click="temp_activity.activity_priority='high';active_priority='high'" :class="{active: active_priority === 'high'}"><i class="fa fa-flag"></i>優先度高</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer text-center block">
              <div name="footer">
                <button v-if="ActivityModal && create_loading == false" class="btn btn-primary" @click="validateBeforeSubmit">
                  建立
                </button>
                <button v-if="ActivityModal && create_loading == true" class="btn btn-primary disabled">
                  建立中...
                </button>
                <button v-if="ActivityModal == false && create_loading == false" class="btn btn-primary" @click="validateBeforeSubmit">
                  修改
                </button>
                <button v-if="ActivityModal == false && create_loading == true" class="btn btn-primary">
                  修改中...
                </button>
                <button class="btn btn-default" @click="cancelAddActivity()">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="showActivityModal" @keyup.esc="showActivityModal=false;showActivity=''">
      <div class="modal-mask" style="background:none;">
        <div class="modal-wrapper " @click="showActivityModal=false;showActivity=''">
          <div class="modal-container modal-center col-md-4" @click.stop>
            <div class="modal-header" style="display:block">
              <div name="header text-center">
                <div class="widget-header margin-bottom-0 clearfix">
                  <div class="pull-right">
                    <a class="row-edit" @click="updateActivityStatus(showActivity,'finish')" v-if="showActivity.activity_status == 'doing'" v-tooltip="'標註為完成'"><i class="fa fa-check text-gray"></i></a>
                    <a class="row-edit" @click="updateActivityStatus(showActivity,'doing')" v-else><i class="fas fa-check-circle text-gray text-success"></i></a>
                    <a class="row-edit" @click="editActivity()" v-tooltip="'編輯'"><i class="fa fa-pen text-gray"></i></a>
                    <a class="row-edit" @click="deleteActivity()" v-tooltip="'刪除'"><i class="fa fa-trash text-gray"></i></a>
                  </div>
                </div>
              </div>
              <a href="#" class="btn-close" @click="showActivityModal=false;showActivity=''">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="text-left modal-body j-forms">
              <h4 class="icon-left-text"><i v-bind:class="showActivityIcon"></i>
                <span v-bind:class="showActivity.activity_priority+'-ball'"></span>{{showActivity.title}}
              </h4>
              <h5 class="icon-left-text"><i class="far fa-clock"></i>{{showActivityTime}}</h5>
              <h5 class="icon-left-text" v-if="showActivity.location"><i class="fas fa-map-marker"></i>{{showActivity.location}}</h5>
              <h5 class="icon-left-text" v-if="showActivity.deal.title"><i class="fa fa-file-invoice-dollar"></i>{{showActivity.deal.title}}</h5>
              <h5 class="icon-left-text" v-if="showActivity.contact.name" ><i class="fa fa-user"></i>{{showActivity.contact.name}} {{showActivity.contact.phone}} {{showActivity.contact.email}}</h5>
              <h5 class="icon-left-text" v-if="showActivity.content"><i class="fas fa-list"></i><pre v-html="showActivity.content"></pre></h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Page Container End Here-->
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker'
import autocomplete from 'vue2-autocomplete-js'
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import zhTwLocale from '@fullcalendar/core/locales/zh-tw';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';


export default {
  name: 'activities',
  data() {
    return {
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      timeZone: moment.tz.guess(), // the default (unnecessary to specify)
      //timeZone: 'local',
      calendarPlugins: [dayGridPlugin,listPlugin,interactionPlugin,timeGridPlugin ],
      locale: zhTwLocale,
      auth_token: {},
      activities: [],
      ActivityModal: false,
      editModal: false,
      showActivityModal: false,
      showActivity: {},
      temp_activity: {},
      activity_priority: 'low',
      content_type: '',
      company_users: [],
      deals: [],
      contact_name: '',
      activities: [],
      activity_categories: [],
      status_filter: 'doing',
      owner_filter: getCookie('activity_owner_filter'),
      view_type: getCookie('calendar_view_type') || 'dayGridMonth',
      type_filter: 'all',
      active_filter: '',
      active_priority: '',
      date_filter: '',
      url: this.axios.defaults.baseURL+'/settings/auto_complete',
      create_loading: false,
    }
  },
  components: {
    Datepicker,
    VueTimepicker,
    autocomplete,
    FullCalendar
  },
  created() {
    this.checkAddParams();
    this.getActivity();
    this.tempActivityReset();
  },
  props: ['toggle_aside'],
  computed: {
    showActivityTime: function(){
      var a = ""
      var start = ""
      var end = ""
      if(this.showActivity.allDay){
        start = moment(this.showActivity.start).format('YYYY/MM/DD')
        end = moment(this.showActivity.end).format('YYYY/MM/DD')
        //校正因為allDay產生的end day 選擇時，時間多1天的問題
        end = moment(this.addDays(new Date(end),-1)).format('YYYY/MM/DD')
        //如果未來能解決，此段拿掉
        if(start==end){
          end = null
        }
      }else{
        start = moment(this.showActivity.start).format('YYYY/MM/DD a hh:mm ')
        end = moment(this.showActivity.end).format('YYYY/MM/DD a hh:mm ')
      }
      if(this.showActivity.end!=null && end!= null){
        a = start + ' ~ ' + end
      }else{
        a = start
      }
      return a
    },
    showActivityIcon: function(){
      let vm = this
      var result = ""
      if(this.showActivity.activity_category_id){
        $.each(this.activity_categories,function(key,value){
          if(parseInt(value.id)==vm.showActivity.activity_category_id){
            result = value.icon
          }
        })
      }
      return result
    }
  },
  methods: {
    checkAddParams(){
     
      if(this.$route.query.add){
        this.ActivityModal=true
      }
    },
    setFilterDealOwner(){
      setCookie('filter_deal_owner', this.owner_filter, 7)
      const vm = this;
      this.axios.get('activities?user_id='+ vm.owner_filter)
        .then(function(response) {
          if (response.status == 200) {
            vm.activities = response['data']['data']['activities']
            vm.user_id = getCookie('filter_deal_owner')
            vm.tempActivityReset()
            // init date filter value to today
          } else {
            // console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });

    },
    'changeMonth' (start, end, current) {
      console.log('changeMonth', start, end, current)
    },
    viewSkeletonRender: function(info) {
      setCookie('calendar_view_type', info.view.type, 7)
    },
    eventClick: function(info) {
      const vm = this
      var calendar = this.$refs.fullCalendar.getApi()
      var activity = this.getActivityById(info.event.id)
      this.showActivityModal=true
      this.showActivity = activity
      console.log('eventClick', event)
      console.log('activity',activity)
    },
    dateClick: function(info) {
      //新增該日期的activity
      let vm=this
      this.temp_activity.start_date = new Date(info.dateStr)
      this.temp_activity.end_date = new Date(info.dateStr)
      this.temp_activity.allDay = info.allDay
      if(info.allDay == false){
        var start_time = new Date(info.dateStr)
        var end_time = new Date((new Date(info.dateStr).getTime() + 30*60000))
        vm.temp_activity.start_time= vm.translateHoursAndMinutes(start_time)
        vm.temp_activity.end_time= vm.translateHoursAndMinutes(end_time)
      }

      this.ActivityModal = true
      console.log('Clicked on: ',info);
      // console.log('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
      // console.log('Current view: ' + info.view.type);
      // change the day's background color just for fun
      //info.dayEl.style.backgroundColor = 'red';
    },
    select: function(info) {
      //新增該日期的activity 用區間選擇
      let vm=this
      this.temp_activity.start_date = new Date(info.startStr)
      this.temp_activity.end_date = new Date(info.endStr)
      this.temp_activity.allDay = info.allDay
      if(info.allDay == false){
        var start_time = new Date(info.startStr)
        var end_time = new Date(info.endStr)
        vm.temp_activity.start_time= vm.translateHoursAndMinutes(start_time)
        vm.temp_activity.end_time= vm.translateHoursAndMinutes(end_time)
      }

      //校正因為allDay產生的end day 選擇時，時間多1天的問題
      if(this.temp_activity.allDay == true){
        this.temp_activity.end_date = this.addDays(new Date(this.temp_activity.end_date),-1)
      }
      //如果未來能解決，此段拿掉

      this.ActivityModal = true
      console.log('select: ',info);
      // console.log('Coordinates: ' + info.jsEvent.pageX + ',' + info.jsEvent.pageY);
      // console.log('Current view: ' + info.view.type);
      // change the day's background color just for fun
      //info.dayEl.style.backgroundColor = 'red';
    },

    moreClick: function(info) {
      console.log('moreClick: ',info);
    },
    eventDrop: function(info) {
      let vm = this
      var e = vm.getActivityById(info.event.id)
      this.changeEventWithCalendar(e,info.event)
    },
    eventResize: function(info) {
      let vm = this
      var e = vm.getActivityById(info.event.id)
      this.changeEventWithCalendar(e,info.event)
    },
    startDateMove: function(date) {
      var days = (new Date(this.temp_activity.end_date) - new Date(this.temp_activity.start_date))/86400000
      var new_start = new Date(date)
      var new_end = new Date(new_start.setDate(new_start.getDate() + days))
      this.temp_activity.end_date = new_end
    },
    translateHoursAndMinutes(datetime){
      //傳入datetime格式。傳出{"HH":hour,"mm":minutes}
      var h = datetime.getHours()
      var m = datetime.getMinutes()
      h = ('0' + h).slice(-2)
      if(m == 0){
        m = "00"
      }
      var result = {'HH':h,'mm':m}
      return result
    },
    cancelAddActivity(){
      this.ActivityModal=false
      this.create_loading = false
      this.editModal=false
      this.tempActivityReset()
    },
    tempActivityReset(){
      this.temp_activity={
        id: '',
        title: '',
        content: '',
        start_date: new Date(),
        start_time: {'HH':(new Date()).getHours(),'mm':'00'},
        start:'',
        end_date: new Date(),
        end_time: {'HH':(new Date()).getHours(),'mm':'30'},
        end:'',
        allDay: true,
        location: '',
        user_id: getCookie('filter_deal_owner'),
        deal_id: '',
        content_type: 'event',
        contact_id: '',
        activity_status: 0,
        activity_priority: 0,
        activity_category_id: null,
        time_warning: false,
        activity_status: 'doing',
      }
    },
    changeEventWithCalendar(old_event,event_api){
      old_event.start = event_api.start
      old_event.end = event_api.end
      old_event.allDay = event_api.allDay
      this.updateActivity(old_event)
      this.syncTempStartEndDate()
    },
    getActivityById(aid){
      let vm=this
      var result={}
      $.each(this.activities,function(key,value){
        if(parseInt(value.id)==parseInt(aid)){
          result = value
        }
      })
      return result
    },
    getActivity(){
      const vm = this;
      vm.auth_token = { 'Auth-Token': getCookie('auth_token') }
      this.axios.get('activities?user_id='+ vm.owner_filter)
        .then(function(response) {
          if (response.status == 200) {
            vm.company_users = response['data']['data']['company_users']
            vm.deals = response['data']['data']['deals']
            vm.activities = response['data']['data']['activities']
            vm.owner_filter = response['data']['data']['current_user']
            vm.user_id = getCookie('filter_deal_owner'),
            vm.activity_categories = response['data']['data']['activity_categories']
            if(getCookie('activity_owner_filter')!= ''){
              vm.owner_filter = getCookie('activity_owner_filter')
              vm.status_filter = getCookie('activity_status_filter')
            }
            if(getCookie('filter_deal_owner')!= ''){
              vm.owner_filter = getCookie('filter_deal_owner')
            }
            // init date filter value to today

          } else {
            // console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    editActivity(){
      //將事項擺入temp_activity
      let vm = this
      this.temp_activity.id = this.showActivity.id
      this.temp_activity.allDay = this.showActivity.allDay
      this.temp_activity.title = this.showActivity.title
      this.temp_activity.content = this.showActivity.content
      this.temp_activity.start = this.showActivity.start
      this.temp_activity.start_date= this.showActivity.start
      this.temp_activity.start_time= this.translateHoursAndMinutes(new Date(vm.showActivity.start))
      this.temp_activity.end = this.showActivity.end || this.showActivity.start
      this.temp_activity.end_date= this.showActivity.end || this.showActivity.start
      //校正因為allDay產生的end day 選擇時，時間多1天的問題
      if(this.temp_activity.allDay == true && this.temp_activity.end_date!=this.temp_activity.start_date){
        this.temp_activity.end_date = this.addDays(new Date(this.temp_activity.end_date),-1)
      }
      //如果未來能解決，此段拿掉
      this.temp_activity.end_time= vm.translateHoursAndMinutes(new Date(vm.temp_activity.end))
      this.temp_activity.location = this.showActivity.location
      this.temp_activity.user_id = this.showActivity.user_id
      this.temp_activity.deal_id = this.showActivity.deal_id
      this.temp_activity.className = this.showActivity.className
      this.temp_activity.contact_id = this.showActivity.contact_id
      this.temp_activity.activity_priority = this.showActivity.activity_priority
      this.temp_activity.activity_category_id = this.showActivity.activity_category_id
      this.temp_activity.activity_status = this.showActivity.activity_status
      this.showActivityModal = false
      this.editModal = true
      // console.log('min', new Date(this.temp_activity.end).getMinutes())
    },
    deleteActivity(){
      console.log('delete it')
      const vm = this;
      this.axios.delete('activities/'+vm.showActivity.id, {
        
      })
      .then(function(response) {
        if (response.status == 200) {
          var index = vm.activities.indexOf(vm.showActivity)
          vm.activities.splice(parseInt(index), 1)
          vm.showActivityModal = false
          vm.create_loading = false
          vm.showActivity = ''
        } else {
          var obj = {
            isShown: true,
            title: '更新失敗、請稍後再試',
            message: '更新失敗',
            type: 'error',
            customCloseBtnText: '關閉'
          }
          vm.refs.simplert.openSimplert(obj);
        }
      })
      .catch(function(error) {
        var obj = {
          isShown: true,
          title: '更新失敗、請稍後再試',
          message: '更新失敗',
          type: 'error',
          customCloseBtnText: '關閉'
        }
        vm.refs.simplert.openSimplert(obj);
      });
    },
    // AutoComplete callback function (Deal)
    process_contact_JSON(json) {
      return json.results.contact;
      console.log(json.results)
    },
    // if Deal selected, auto assign deal name 
    handle_contact_Select(data) {
      this.temp_activity.contact_id = data.id
    },
    // keyup Deal name
    set_contact_Value(value) {
      this.contact_name = value
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.add_activity();
        } else {
          console.log('fails')
        }
      });
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    syncTempStartEndDate(){
      if(this.temp_activity.allDay == true){
        this.temp_activity.start = moment.tz(this.temp_activity.start_date, this.timeZone).set({hour:0,minute:0,second:0,millisecond:0})
        this.temp_activity.end = moment.tz(this.temp_activity.end_date, this.timeZone).set({hour:0,minute:0,second:0,millisecond:0})
      }else{
        this.temp_activity.start = moment.tz(this.temp_activity.start_date, this.timeZone).set({hour:this.temp_activity.start_time.HH,minute:this.temp_activity.start_time.mm,second:0,millisecond:0})
        this.temp_activity.end = moment.tz(this.temp_activity.end_date, this.timeZone).set({hour:this.temp_activity.end_time.HH,minute:this.temp_activity.end_time.mm,second:0,millisecond:0})
      }

      var a =  this.temp_activity.end - this.temp_activity.start
      if(a<0){
        this.temp_activity.time_warning = true
        var result = false
      }else{
        var result = true
      }
      //校正因為allDay產生的end day 選擇時，時間多1天的問題
      if(this.temp_activity.allDay == true){
        this.temp_activity.end = this.addDays(new Date(this.temp_activity.end_date),1)
      }
      //如果未來能解決，此段拿掉

      return result
    },
    add_activity() {
      const vm = this;
      console.log('submit')
      var check_time = this.syncTempStartEndDate() 
      if(check_time == false){
        return
      }
      if(vm.temp_activity.id==''){
        //新增
        this.axios.post('activities', {
          activity: vm.temp_activity,
          activity_type: 'activity',
          content_type: 'event',
        })
        .then(function(response) {
          if (response.status == 200) {
            var new_event= response['data']['data']['activity']
            console.log(response['data']['data']['activity'])
            if(vm.temp_activity.user_id==vm.owner_filter){
              vm.activities.push(new_event)
            }
            vm.cancelAddActivity()
          } else {
            // console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
      }else{
        //更新
        this.axios.put('activities/'+vm.temp_activity.id, {
          activity: vm.temp_activity,
        })
        .then(function(response) {
          if (response.status == 200) {
            var new_event= response['data']['data']['activity']
            console.log(response['data']['data']['activity'])
            if(vm.temp_activity.user_id==vm.owner_filter){
              var oldActivity = vm.getActivityById(vm.temp_activity.id)
              var index = vm.activities.indexOf(oldActivity)
              vm.activities.splice(parseInt(index), 1)
              var new_event = response['data']['data']['activity']
              vm.activities.push(new_event)
            }else{
              var oldActivity = vm.getActivityById(vm.temp_activity.id)
              var index = vm.activities.indexOf(oldActivity)
              vm.activities.splice(parseInt(index), 1)
            }
            vm.cancelAddActivity()
          } else {
            // console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
      }
    },
    updateActivity(activity){
      const vm = this;
      var oldActivity = vm.getActivityById(activity.id)
      // console.log('oldActivity ',oldActivity )
      var index = vm.activities.indexOf(oldActivity)
      vm.activities.splice(parseInt(index), 1)
      var new_event = activity
      // console.log('new_event',new_event)
      vm.activities.push(new_event)
      this.axios.put('activities/'+activity.id, {
        activity: activity
      })
      .then(function(response) {
        if (response.status == 200) {
          // var new_event= response['data']['data']['activity']
          // console.log(response['data']['data']['activity'])
          // if(vm.temp_activity.user_id==vm.owner_filter){
            
          // }
          vm.cancelAddActivity()
        }else{
          console.log('error')
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    updateActivityStatus(activity,status){
      // fade out activity on frontend first
      activity.activity_status = status
      activity.className = activity.activity_priority + ' ' + activity.activity_status
      // add success_activities_count
      this.updateActivity(activity)
    },
    CookieChange(target, value){
      setCookie(target, value, 7)
    },
    custoter(date) {
      moment.locale('zh-tw');
      return moment(date)('YYYY MMM Do');
    },
    goSetting(){
      this.$router.push('/setting/activity_categories')
    }
  }
} 
</script>


// WEBPACK FOOTER //
// ActivityList.vue?5c4444e7